function removeElement(elment) {
  elment.parentNode.removeChild(elment)
}

function createBtn(className, type = null) {
  let btn = document.createElement('button')
  btn.setAttribute('type', 'button')

  if (type) btn.setAttribute('aria-label', type)

  let classNames = className.split(' ')

  classNames.forEach((name) => btn.classList.add(name))

  return btn
}

export const dots = (slider) => {
  if (slider.slides.length <= 1) return

  let container

  function createDots() {
    container = document.createElement('fieldset')
    container.className = 'slider--dots'
    container.role = 'radiogroup'

    slider.track.details.slides.forEach((_, idx) => {
      const input = document.createElement('input')
      input.type = 'radio'
      input.name = 'keen--slider-dots'
      input.id = `keen-dot-${idx}`

      const label = document.createElement('label')
      label.setAttribute('for', input.id)

      input.addEventListener('change', () => {
        if (input.checked) {
          slider.moveToIdx(idx)
        }
      })

      container.appendChild(input)
      container.appendChild(label)
    })

    slider.container.parentNode.appendChild(container)
  }

  function updateDots() {
    const current = slider.track.details.rel
    const inputs = container.querySelectorAll('input')

    if (inputs[current]) {
      inputs[current].checked = true
    }
  }

  slider.on('created', () => {
    createDots()
    updateDots()
  })

  slider.on('slideChanged', updateDots)
}

export const arrows = (slider) => {
  if (slider.slides.length <= 1) return

  let container = document.createElement('nav')
  container.className = 'slider--btns'

  let arrowLeft, arrowRight

  const markup = (remove) => createArrows(remove)

  function createArrows(remove) {
    if (remove) {
      removeElement(arrowLeft)
      removeElement(arrowRight)
      return
    }

    arrowLeft = createBtn('slider--btn prev' + (slider.options.loop === false ? ' disabled' : ''), 'Previous slide')
    arrowLeft.addEventListener('click', () => slider.prev())
    arrowRight = createBtn('slider--btn next', 'Next slide')
    arrowRight.addEventListener('click', () => slider.next())

    container.appendChild(arrowLeft)
    container.appendChild(arrowRight)

    slider.container.parentNode.appendChild(container)
  }

  function updateClasses() {
    if (slider.options.loop === true) return

    let slide = slider.track.details.rel

    slide === 0 ? arrowLeft.classList.add('disabled') : arrowLeft.classList.remove('disabled')

    slide === slider.track.details.slides.length - 1 ? arrowRight.classList.add('disabled') : arrowRight.classList.remove('disabled')

    if (slider.track.details.maxIdx === slide) {
      arrowLeft.classList.remove('disabled')
      arrowRight.classList.add('disabled')
    }
  }

  slider.on('created', () => {
    markup()
    updateClasses()
  })

  slider.on('optionsChanged', () => {
    markup(true)
    markup()
    updateClasses()
  })

  slider.on('slideChanged', () => updateClasses())
  slider.on('destroyed', () => markup(true))
}

export const autoPlay = (slider) => {
  let timeout
  let mouseOver = false

  function clearNextTimeout() {
    clearTimeout(timeout)
  }

  function nextTimeout() {
    clearTimeout(timeout)

    if (mouseOver) return

    timeout = setTimeout(() => {
      slider.next()
    }, 2000)
  }

  slider.on('created', () => {
    slider.container.addEventListener('mouseover', () => {
      mouseOver = true
      clearNextTimeout()
    })

    slider.container.addEventListener('mouseout', () => {
      mouseOver = false
      nextTimeout()
    })

    nextTimeout()
  })

  slider.on('dragStarted', clearNextTimeout)
  slider.on('animationEnded', nextTimeout)
  slider.on('updated', nextTimeout)
}

export const keyboard = (slider) => {
  if (slider.slides.length <= 1) return

  document.addEventListener('keydown', ({ key }) => {
    if (!key) return

    if (key === 'ArrowLeft') slider.prev()

    if (key === 'ArrowRight') slider.next()
  })
}
